/**
 * Generated by orval v8.5.3 🍺
 * Do not edit manually.
 * Space Invoices API
 * REST API for invoice management, customer management, and accounting operations. Features include cursor-based pagination for efficient data navigation, flexible JSON querying with MongoDB-style operators, full-text search across multiple fields, and comprehensive metadata support for custom tracking.
 * OpenAPI spec version: 1.0.0
 */
import type {
  Error,
  FileMetadata,
  GetFiles200,
  GetFilesParams,
  UploadFileBody,
  ValidationError
} from '../model';

import { customFetch } from '../../mutator/custom-fetch';

/**
 * Upload a file (logo, signature, or attachment) to cloud storage.
Files are automatically optimized and stored in entity-specific folders.
Logos and signatures are entity-level (one per entity), while attachments can be associated with specific documents.
 * @summary Upload a file
 */
export type uploadFileResponse201 = {
  data: FileMetadata
  status: 201
}

export type uploadFileResponse400 = {
  data: Error
  status: 400
}

export type uploadFileResponse401 = {
  data: Error
  status: 401
}

export type uploadFileResponse403 = {
  data: Error
  status: 403
}

export type uploadFileResponse404 = {
  data: Error
  status: 404
}

export type uploadFileResponse422 = {
  data: ValidationError
  status: 422
}

export type uploadFileResponse500 = {
  data: Error
  status: 500
}

export type uploadFileResponseSuccess = (uploadFileResponse201) & {
  headers: Headers;
};
export type uploadFileResponseError = (uploadFileResponse400 | uploadFileResponse401 | uploadFileResponse403 | uploadFileResponse404 | uploadFileResponse422 | uploadFileResponse500) & {
  headers: Headers;
};

export type uploadFileResponse = (uploadFileResponseSuccess | uploadFileResponseError)

export const getUploadFileUrl = () => {


  

  return `/files`
}

export const uploadFile = async (uploadFileBody: UploadFileBody, options?: RequestInit): Promise<uploadFileResponse> => {
    const formData = new FormData();
if(uploadFileBody.file !== undefined) {
 formData.append(`file`, uploadFileBody.file);
 }
formData.append(`category`, uploadFileBody.category);
if(uploadFileBody.account_payable_id !== undefined) {
 formData.append(`account_payable_id`, uploadFileBody.account_payable_id);
 }
if(uploadFileBody.incoming_purchase_document_id !== undefined) {
 formData.append(`incoming_purchase_document_id`, uploadFileBody.incoming_purchase_document_id);
 }

  return customFetch<uploadFileResponse>(getUploadFileUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}
  

/**
 * Retrieve a paginated list of files for an entity.
Supports filtering by category and optional document association.
 * @summary List all files
 */
export type getFilesResponse200 = {
  data: GetFiles200
  status: 200
}

export type getFilesResponse400 = {
  data: Error
  status: 400
}

export type getFilesResponse401 = {
  data: Error
  status: 401
}

export type getFilesResponse403 = {
  data: Error
  status: 403
}

export type getFilesResponse404 = {
  data: Error
  status: 404
}

export type getFilesResponse500 = {
  data: Error
  status: 500
}

export type getFilesResponseSuccess = (getFilesResponse200) & {
  headers: Headers;
};
export type getFilesResponseError = (getFilesResponse400 | getFilesResponse401 | getFilesResponse403 | getFilesResponse404 | getFilesResponse500) & {
  headers: Headers;
};

export type getFilesResponse = (getFilesResponseSuccess | getFilesResponseError)

export const getGetFilesUrl = (params?: GetFilesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/files?${stringifiedParams}` : `/files`
}

export const getFiles = async (params?: GetFilesParams, options?: RequestInit): Promise<getFilesResponse> => {
  
  return customFetch<getFilesResponse>(getGetFilesUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Retrieve file metadata by its unique identifier.
 * @summary Get file metadata by ID
 */
export type getFileByIdResponse200 = {
  data: FileMetadata
  status: 200
}

export type getFileByIdResponse401 = {
  data: Error
  status: 401
}

export type getFileByIdResponse403 = {
  data: Error
  status: 403
}

export type getFileByIdResponse404 = {
  data: Error
  status: 404
}

export type getFileByIdResponse500 = {
  data: Error
  status: 500
}

export type getFileByIdResponseSuccess = (getFileByIdResponse200) & {
  headers: Headers;
};
export type getFileByIdResponseError = (getFileByIdResponse401 | getFileByIdResponse403 | getFileByIdResponse404 | getFileByIdResponse500) & {
  headers: Headers;
};

export type getFileByIdResponse = (getFileByIdResponseSuccess | getFileByIdResponseError)

export const getGetFileByIdUrl = (id: string,) => {


  

  return `/files/${id}`
}

export const getFileById = async (id: string, options?: RequestInit): Promise<getFileByIdResponse> => {
  
  return customFetch<getFileByIdResponse>(getGetFileByIdUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}
  

/**
 * Delete a file and its metadata.
The file is removed from cloud storage and the database.
 * @summary Delete a file
 */
export type deleteFileResponse204 = {
  data: void
  status: 204
}

export type deleteFileResponse401 = {
  data: Error
  status: 401
}

export type deleteFileResponse403 = {
  data: Error
  status: 403
}

export type deleteFileResponse404 = {
  data: Error
  status: 404
}

export type deleteFileResponse500 = {
  data: Error
  status: 500
}

export type deleteFileResponseSuccess = (deleteFileResponse204) & {
  headers: Headers;
};
export type deleteFileResponseError = (deleteFileResponse401 | deleteFileResponse403 | deleteFileResponse404 | deleteFileResponse500) & {
  headers: Headers;
};

export type deleteFileResponse = (deleteFileResponseSuccess | deleteFileResponseError)

export const getDeleteFileUrl = (id: string,) => {


  

  return `/files/${id}`
}

export const deleteFile = async (id: string, options?: RequestInit): Promise<deleteFileResponse> => {
  
  return customFetch<deleteFileResponse>(getDeleteFileUrl(id),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}
  

